import { AxiosError } from 'axios';
import { textsCommon, textsSettings } from 'texts/index';
import { ICustomMap } from 'types/ICustomMap';

// swiftpassweb's /installer-links answers these two failures with a bare `{ error }` body, which none of
// the shapes below read. Matched on status AND the exact words, so no other 502/503 is rewritten.
const installerLinksFailure = (error: AxiosError | ICustomMap): string | undefined => {
    const status = error.response?.status;
    // A create that may have gone through: swiftpassweb's portal call timed out after sending (504 with
    // maybe_created), or the browser got no answer at all. The link may exist, and so may the text.
    if (status === 504 && error.response?.data?.maybe_created === true) return textsSettings.installerLinkNotConfirmed;
    if (!error.response && error.config?.method?.toLowerCase() === 'post' && /^\/?installer-links\/?$/.test(error.config?.url ?? '')) {
        return textsSettings.installerLinkNotConfirmed;
    }
    const body = error.response?.data?.error;
    // The portal passes its ALREADY_ENDED code through as the message too, which reads as a code.
    if (status === 409 && error.response?.data?.code === 'ALREADY_ENDED') return textsSettings.installerLinkAlreadyEnded;
    if (status === 503 && body === 'Installer links are not configured') return textsSettings.installerLinksNotConfigured;
    if (status === 502 && body === 'Partner portal unavailable') return textsSettings.installerLinksPortalUnavailable;
    return undefined;
};

export const getErrorMsg = (error: AxiosError | ICustomMap): string => {
    const installerLinks = installerLinksFailure(error);
    if (installerLinks) return installerLinks;
    if (error.response) {
        return (
            error.response?.data?.msg ||
            error?.response?.data?.data?.msg ||
            error?.response?.data?.message ||
            error?.response?.data?.detail?.msg ||
            error?.response?.data?.detail?.[0]?.msg ||
            error?.response?.data?.data?.message ||
            error?.response?.data?.error_description ||
            textsCommon.errorHappened
        );
    }
    return textsCommon.errorHappened;
};

export const getSuccessMsg = (respData: ICustomMap | string): string =>
    typeof respData === 'string' ? respData : respData?.msg || respData?.message || respData?.data?.msg || respData?.data?.message;
